import React from 'react';
// import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// import { RootDispatch } from '../../store';
import OrgHeader from '../OrgHeader';

import styles from './Invalid.module.css';

function InvalidComponent(/*{ showInputAccessCode }: { showInputAccessCode: Function }*/) {
  return (
    <div className={styles.container}>
      <OrgHeader className={styles.orgHeader} />
      <div className={styles.body}>
        <span className={styles.header}>
          <FormattedMessage id={`conversationExpired.expired`} />
        </span>
        {/* <div className={styles.copy}>Tap below to request a new conversation with your provider.</div>
        <button
          className={styles.requestButton}
          onClick={() => {
            console.log('requesting access code');
            showInputAccessCode();
          }}
        >
          Request
        </button> */}
      </div>
    </div>
  );
}

// const mapDispatch = ({ currentPage: { showInputAccessCode } }: RootDispatch) => ({
//   showInputAccessCode,
// });

export const Invalid = InvalidComponent; // connect(null, mapDispatch)(InvalidComponent);

export default Invalid;
